<template>
<div class="chapter">
<div class="inner_page">
<p class="also1">Also by Erin McHugh</p>
<p class="also"><em>One Good Deed<br/>Like My Mother Always Said<br/>Like My Father Always Said<br/>Like My Teacher Always Said</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?5114866a